import { Outlet, ScrollRestoration } from "react-router";
import { Stack } from "@mui/material";
import { pageLayout } from "@/theme/pageLayout";
import SuperAdminHeader from "@/components/app/SuperAdminHeader";

const SuperAdminLayout = () => {
  return (
    <Stack minHeight="100vh">
      <ScrollRestoration />
      <SuperAdminHeader />
      <Stack sx={{ ...pageLayout, pt: 3, pb: 25 }} flex={1}>
        <Outlet />
      </Stack>
    </Stack>
  );
};

export default SuperAdminLayout;
